// extracted by mini-css-extract-plugin
export default {"diagnosis-list-box":"DiagnosisMore_diagnosis-list-box__PRBjR","head":"DiagnosisMore_head__Zp7XD","bottom":"DiagnosisMore_bottom__pnF93"};